export const UPDATE_TEXTAREA_FOCUS = 'UPDATE_TEXTAREA_FOCUS';

export function blurTextArea() {
  return {
    type: UPDATE_TEXTAREA_FOCUS,
    payload: {
      hasTextAreaFocus: false
    }
  };
}

export function focusTextArea() {
  return {
    type: UPDATE_TEXTAREA_FOCUS,
    payload: {
      hasTextAreaFocus: true
    }
  };
}
